
import {
    Flex, Text, SimpleGrid, Button, Divider, VStack, Stack,
    FormControl, FormLabel, Input, Icon, Link, FormErrorMessage,
    useToast, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter
} from '@chakra-ui/react'

import { Link as ReactLink, useHistory } from 'react-router-dom'
import { BsBoxArrowInDown, BsArrowCounterclockwise, BsBoxArrowInRight } from "react-icons/bs";
import { useForm, Controller } from "react-hook-form";
import RegisterUser, { postRegister } from '../../classes/RegisterUser'
import { ModalLoading, SelectOffice, SelectLevel, SelectTitleName, InputIDCard, InputTelephoneNumber, InputPassword } from '../shared';
import { toastErrDesc, toastVal } from '../../utils/toastUtils';
import { useEffect, useRef, useState } from 'react';
import { setLocalUserData, updateUserData, useUserContext } from '../../context/userContext';
import { useLoadingContext } from '../../context/loadingContext';
import LoginUser, { postLogin } from '../../classes/LoginUser';
import User from '../../classes/User';

const ModalUserRegister = ({ open, login }) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const toast = useToast()
    const { dispatchUserData } = useUserContext()
    const { onModalClose, onModalOpen } = useLoadingContext()
    const history = useHistory();

    const loginHandle = () => {
        const loginData = new LoginUser(login)
        // console.log(loginData.serialized())
        onModalOpen("กำลังเข้าสู่ระบบ")

        postLogin(loginData.serialized())
            .then(res => {
                const param = {
                    ...res.user,
                    token: res.token,
                    authorized: true,
                }
                const loginUser = new User(param)
                // console.log("-- post ok")
                // console.log(loginUser)
                onModalClose()
                setLocalUserData(loginUser)
                dispatchUserData(updateUserData(loginUser))
                //redirect to /
                history.push("/")

            })
            .catch(error => {
                onModalClose()
                // console.log("-- post fail")
                // console.log(error)
                toast(toastVal({
                    title: "การเข้าสู่ระบบ ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    const openModal = useRef()
    openModal.current = () => {
        if (open) {
            onOpen()
        }
    }

    useEffect(() => {
        openModal.current()
    }, [open])

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xl" closeOnOverlayClick={false} motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>ลงทะเบียนสำเร็จ</ModalHeader>
                <ModalBody>
                    <VStack>
                        <Text>การลงทะเบียนเสร็จเรียบร้อย</Text>
                        <Text>กรุณาใช้<Text as="u">ชื่อบัญชีและรหัสผ่าน</Text>ของท่านเพื่อเข้าใช้งานครั้งต่อไป</Text>
                        <Text>ชื่อบัญชีของท่านคือ</Text>
                        <Text fontSize="4xl" color="red.600">{login.username}</Text>
                        <Text>ชื่อผู้สมัคร <Text as="span" fontWeight="bold" bgColor="yellow.200" px={2}>{login.full_name}</Text></Text>
                        <Text mt={3}>ระบบได้ส่งข้อความผลการลงทะเบียนไปที่อีเมล</Text>
                        <Text><Text as="span" fontWeight="bold"  bgColor="yellow.200" px={2}>{login.email}</Text> เรียบร้อยแล้ว</Text>
                        <Text>กดปุ่ม <Text as="span" fontWeight="bold">เข้าสู่ระบบ</Text> เพื่อเข้าใช้งานระบบ</Text>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Flex w="full" justify="center">
                        <Button leftIcon={<BsBoxArrowInRight />} colorScheme="green" onClick={loginHandle}>
                            เข้าสู่ระบบ
                        </Button>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

const RegisterForm = () => {
    const { control, handleSubmit, formState: { errors }, watch, reset, setError } = useForm()
    const toast = useToast()
    const { onClose, onOpen, isOpen } = useDisclosure()
    const [successModal, setSuccessModal] = useState({ open: false, username: "", password: "" })

    const resetForm = () => {
        reset({
            title: null,
            level: null,
            office: null,
            first_name: "",
            last_name: "",
            id_card: "",
            tel: "",
            email: "",
            position: "",
            password: "",
            confirm_password: "",
        })
    }

    const onSubmit = data => {
        // id card
        data.id_card = data.id_card?.replaceAll(" ", "").replaceAll("_", "")
        if (data.id_card.length !== 13) {
            setError("id_card", { type: 'invalid', message: 'รูปแบบเลขประจำตัวประชาชนไม่ถูกต้อง' }, { shouldFocus: true })
            toast(toastVal({
                title: "กรุณาตรวจสอบการกรอกข้อมูล!",
                description: "รูปแบบเลขประจำตัวประชาชนไม่ถูกต้อง",
                status: "error",
            }))
            return;
        }

        // tel
        data.tel = data.tel?.replaceAll(" ", "").replaceAll("_", "")
        if (data.tel.length !== 10) {
            setError("tel", { type: 'invalid', message: 'รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง' }, { shouldFocus: true })
            toast(toastVal({
                title: "กรุณาตรวจสอบการกรอกข้อมูล!",
                description: "รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง",
                status: "error",
            }))
            return;
        }

        const regData = new RegisterUser(data)
        //console.log(regData.serialized())
        onOpen()

        postRegister(regData.serialized())
            .then(res => {
                // console.log("-- post ok")
                // console.log(res)
                onClose()
                resetForm()
                toast(toastVal({
                    title: "การบันทึกข้อมูลสำเร็จ",
                    description: `บันทึกข้อมูลการสมัครของ ${res.full_name} เรียบร้อยแล้ว`,
                }))

                // modal
                setSuccessModal({
                    open: true,
                    username: res.username,
                    password: regData.password,
                    full_name: res.full_name,
                    email: res.email
                })
            })
            .catch(error => {
                onClose()
                // console.log("-- post fail")
                // console.log(error)
                toast(toastVal({
                    title: "การบันทึกข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }



    return (
        <Flex direction="column" w={{base:"full",md:"90%"}} justify="center" mt={4}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <VStack spacing={3} mt={4} >
                    <SimpleGrid columns={{ sm: 1, lg: 2 }} spacing={4} w="full" p={4}>
                        <Flex justify="center" align="start" display={{ sm: "none", lg: "flex" }}>
                            <Text fontWeight="bold" fontSize="lg">ข้อมูลส่วนตัว</Text>
                        </Flex>
                        <Flex direction="column" w="full">
                            <Stack w="full" direction={{ base: "column", lg: "row" }}>
                                <FormControl isInvalid={errors.title} isRequired>
                                    <FormLabel>คำนำหน้าชื่อ</FormLabel>
                                    <SelectTitleName control={control} />
                                    {errors.title && <FormErrorMessage>กรุณาเลือกคำนำหน้าชื่อ</FormErrorMessage>}
                                </FormControl>
                                <FormControl isInvalid={errors.first_name} isRequired>
                                    <FormLabel>ชื่อ</FormLabel>
                                    <Controller
                                        name="first_name"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => <Input type="text" maxLength={100} placeholder="กรอกชื่อ" {...field} />}
                                    />
                                </FormControl>
                                <FormControl isInvalid={errors.last_name} isRequired>
                                    <FormLabel>นามสกุล</FormLabel>
                                    <Controller name="last_name"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field }) => <Input type="text" maxLength={100} placeholder="กรอกนามสกุล" {...field} />}
                                    />
                                </FormControl>
                            </Stack>
                            <FormControl isInvalid={errors.id_card} mt={2} isRequired>
                                <FormLabel>เลขบัตรประชาชน</FormLabel>
                                <InputIDCard control={control} />
                                <FormErrorMessage>{errors.id_card?.message || "กรอกหมายเลขบัตรประชาชน"}</FormErrorMessage>
                            </FormControl>
                            <FormControl isInvalid={errors.email} mt={2} isRequired>
                                <FormLabel>อีเมล</FormLabel>
                                <Controller
                                    name="email"
                                    control={control}
                                    rules={{ pattern: /^\S+@\S+$/i, required: true }}
                                    render={({ field }) => <Input type="text" maxLength={100} placeholder="กรอกอีเมล" {...field} />}
                                />
                                <FormErrorMessage>กรุณากรอกอีเมลให้ถูกต้อง</FormErrorMessage>
                            </FormControl>
                            <FormControl isInvalid={errors.tel} mt={2} isRequired>
                                <FormLabel>หมายเลขโทรศัพท์มือถือ</FormLabel>
                                <InputTelephoneNumber control={control} />
                                <FormErrorMessage>{errors.tel?.message || "กรอกหมายเลขโทรศัพท์"}</FormErrorMessage>
                            </FormControl>
                        </Flex>
                    </SimpleGrid>
                    <Divider />
                    <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={4} w="full" p={4}>
                        <Flex justify="center" align="start" display={{ sm: "none", lg: "flex" }}>
                            <Text fontWeight="bold" fontSize="lg">ตำแหน่งและหน่วยงาน</Text>
                        </Flex>
                        <Flex direction="column" w="full">
                            <FormControl isInvalid={errors.position} isRequired>
                                <FormLabel>ชื่อตำแหน่ง</FormLabel>
                                <Controller name="position"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field }) => <Input type="text" maxLength={150} placeholder="กรอกชื่อตำแหน่ง" {...field} />}
                                />
                            </FormControl>
                            <FormControl mt={2} isInvalid={errors.level} isRequired>
                                <FormLabel>ระดับ</FormLabel>
                                <SelectLevel control={control} />
                                {errors.level && <FormErrorMessage>กรุณาเลือกระดับ</FormErrorMessage>}
                            </FormControl>
                            <FormControl mt={2} isInvalid={errors.office} isRequired>
                                <FormLabel>หน่วยงาน</FormLabel>
                                <SelectOffice control={control} />
                                {errors.office && <FormErrorMessage>กรุณาเลือกหน่วยงาน</FormErrorMessage>}
                            </FormControl>
                        </Flex>
                    </SimpleGrid>
                    <Divider />
                    <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={4} w="full" p={4}>
                        <Flex justify="center" align="start" display={{ sm: "none", lg: "flex" }}>
                            <Text fontWeight="bold" fontSize="lg">ตั้งรหัสผ่าน</Text>
                        </Flex>
                        <Flex direction="column" w="full">
                            <FormControl isInvalid={errors.password} isRequired>
                                <FormLabel>รหัสผ่าน</FormLabel>
                                <InputPassword control={control} name="password" placeholder="กรอกรหัสผ่าน 6-20 ตัวอักษร" />
                                {errors.password?.type === 'minLength' && <FormErrorMessage>ความยาวรหัสผ่านอย่างน้อย 6 ตัวอักษร</FormErrorMessage>}
                            </FormControl>
                            <FormControl mt={2} isInvalid={errors.confirm_password} isRequired>
                                <FormLabel>ยืนยันรหัสผ่าน</FormLabel>
                                <InputPassword control={control} name="confirm_password" validateValue={watch("password")} placeholder="กรอกรหัสผ่านอีกครั้ง" />
                                {errors.confirm_password?.type === 'validate' && <FormErrorMessage>ยืนยันรหัสผ่านไม่ตรงกัน</FormErrorMessage>}
                                {errors.confirm_password?.type === 'minLength' && <FormErrorMessage>ความยาวรหัสผ่านอย่างน้อย 6 ตัวอักษร</FormErrorMessage>}
                            </FormControl>
                        </Flex>
                    </SimpleGrid>
                </VStack>
                <VStack w="full">
                    <Stack mt={4} direction={{base:"column",md:"row"}} w={{base:"full",md:"fit-content"}}>
                        <Button type="submit" colorScheme="blue" fontSize="md" w={{base:"full",md:"fit-content"}} leftIcon={<Icon as={BsBoxArrowInDown} />}>
                            บันทึกข้อมูลการสมัคร
                        </Button>
                        <Button type="reset" colorScheme="yellow" fontSize="md" w={{base:"full",md:"fit-content"}} leftIcon={<Icon as={BsArrowCounterclockwise} />} onClick={() => resetForm()}>
                            ล้างฟอร์ม
                        </Button>
                    </Stack>
                    <Link to="/" as={ReactLink}>
                        <Button fontSize="md" variant="link" mt={4}>
                            กลับหน้าหลัก
                        </Button>
                    </Link>
                </VStack>
            </form>

            <ModalLoading onClose={onClose} isOpen={isOpen} />
            <ModalUserRegister open={successModal?.open} login={successModal} />
        </Flex>
    )
}

export default RegisterForm
